import {
  eventAlerts,
  GetKgInsightSubscriptionResponse,
  PostAlertsRequest,
  PostAlertsV2Request,
  PostKgInsightSubscriptionRequest,
  PostReadRequest,
  PostSubscriptionRequest,
  SourceType,
} from '@api/api/event-alerts';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const postAlerts = (body: PostAlertsRequest) =>
  wretchRequest(eventAlerts.postAlerts.path, {
    method: 'post',
    body,
    schema: eventAlerts.postAlerts.schema,
  });

export const postAlertsV2 = (body: PostAlertsV2Request) =>
  wretchRequest(eventAlerts.postAlertsV2.path, {
    method: 'post',
    body,
    schema: eventAlerts.postAlertsV2.schema,
  });

export const postSubscription = (body: PostSubscriptionRequest) =>
  wretchRequest(eventAlerts.postSubscriptions.path, {
    method: 'post',
    body,
  });

export const postKgInsightSubscription = (
  body: PostKgInsightSubscriptionRequest
) =>
  wretchRequest(eventAlerts.postKgInsightSubscription.path, {
    method: 'post',
    body,
  });

export const getKgInsightSubscription = (entityTag: string) =>
  wretchRequest<GetKgInsightSubscriptionResponse>(
    eventAlerts.getKgInsightSubscription.path(entityTag),
    {
      schema: eventAlerts.getKgInsightSubscription.schema,
    }
  );

export const getSingleSubscription = ({
  sourceType,
  sourceId,
}: {
  sourceType: SourceType;
  sourceId: string;
}) =>
  wretchRequest(
    eventAlerts.getSingleSubscription.path({ sourceType, sourceId }),
    {
      schema: eventAlerts.getSingleSubscription.schema,
    }
  );

export const getSubscriptions = ({
  sourceType,
  next,
  limit,
}: {
  sourceType: SourceType;
  limit?: number;
  next?: string;
}) =>
  wretchRequest(
    eventAlerts.getSubscriptions.path({ sourceType, next, limit }),
    {
      schema: eventAlerts.getSubscriptions.schema,
    }
  );

export const postRead = (body: PostReadRequest) =>
  wretchRequest(eventAlerts.postRead.path, {
    method: 'post',
    body,
  });

export const postReadAll = () =>
  wretchRequest(eventAlerts.postReadAll.path, {
    method: 'post',
  });
